import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { OrgAdminSidebarComponent } from '../sidebar/org-admin-sidebar.component';
import { DatasetProviderDashboardComponent } from '../../shared/components/dataset-provider-dashboard/dataset-provider-dashboard.component';
import { RolesApiService, Role } from '@angular-workspace/services';
import { ToasterService } from '../../services/toaster.service';

@Component({
  selector: 'app-org-admin-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    OrgAdminSidebarComponent,
    DatasetProviderDashboardComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class OrgAdminDashboardComponent implements OnInit {
  private rolesService = inject(RolesApiService);
  private router = inject(Router);
  private toasterService = inject(ToasterService);

  canAccess = false;
  isChecking = true;

  async ngOnInit(): Promise<void> {
    await this.checkOrgAdminRole();
  }

  private async checkOrgAdminRole(): Promise<void> {
    try {
      await this.rolesService.getRoles();
      const userRoles = this.rolesService.getUserRoles();

      if (userRoles && userRoles.length > 0) {
        const highestRolePanelRoute = this.rolesService.getHighestRolePanelRoute(userRoles);

        const hasOrgAdminRole = userRoles.some(role => {
          const normalizedRole = role.toLowerCase().replace(/_/g, '-');
          return normalizedRole === 'org-admin' || normalizedRole === Role.ORG_ADMIN;
        });

        const hasCosAdminRole = userRoles.some(role => {
          const normalizedRole = role.toLowerCase().replace(/_/g, '-');
          return normalizedRole === 'cos-admin' || normalizedRole === 'cos_admin';
        });

        if (hasCosAdminRole && highestRolePanelRoute.startsWith('/admin')) {
          this.toasterService.warning("You don't have access to some of the panels.");
          this.router.navigate([highestRolePanelRoute], { replaceUrl: true });
          return;
        }

        if (!hasOrgAdminRole) {
          this.toasterService.warning("You don't have access to some of the panels.");
          this.router.navigate([highestRolePanelRoute], { replaceUrl: true });
          return;
        }

        this.canAccess = true;
      } else {
        this.toasterService.warning("You don't have access to some of the panels.");
        this.router.navigate(['/'], { replaceUrl: true });
      }
    } catch (error) {
      console.error('Error checking roles:', error);
      this.toasterService.warning("You don't have access to some of the panels.");
      this.router.navigate(['/'], { replaceUrl: true });
    } finally {
      this.isChecking = false;
    }
  }
}
